<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        @if (isMultiple) {
            <kendo-multiselect
                *subscribe="query$ as query"
                [ngClass]="generateInputStyle()"
                [id]="id"
                [title]="title | translate"
                [textField]="textField"
                [valueField]="valueField"
                [fillMode]="'flat'"
                [valuePrimitive]="true"
                [filterable]="true"
                [autoClose]="false"
                [data]="filteredOptions()"
                [popupSettings]="popupSettings"
                [clearButton]="!isRequired"
                [readonly]="isDisabled"
                [itemDisabled]="itemDisabled"
                [loading]="query?.isLoading"
                [(ngModel)]="value"
                (valueChange)="onValueChange($event)"
                (filterChange)="queryCodelistDebounced($event)"
                (inputFocus)="onFocusIn()"
                (inputBlur)="onFocusOut()">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <div class="p-1">
                        <label class="k-checkbox-label">{{ dataItem.label | translate }}</label>
                    </div>
                </ng-template>
                <kendo-multiselect-messages [noDataText]="'No data found' | translate" />
            </kendo-multiselect>
        } @else {
            <kendo-combobox
                data-container="body"
                *subscribe="query$ as query"
                [ngClass]="generateInputStyle()"
                [id]="id"
                [title]="title | translate"
                [textField]="textField"
                [valueField]="valueField"
                [valuePrimitive]="true"
                [data]="filteredOptions()"
                [filterable]="true"
                [clearButton]="!isRequired"
                [disabled]="isDisabled"
                [readonly]="isDisabled"
                [loading]="query?.isLoading"
                [popupSettings]="popupSettings"
                [placeholder]="placeholder"
                [(ngModel)]="value"
                (valueChange)="onValueChange($event)"
                (filterChange)="queryCodelistDebounced($event)"
                (inputFocus)="onFocusIn()"
                (inputBlur)="onFocusOut()">
                <kendo-combobox-messages [noDataText]="'No data found' | translate" />
            </kendo-combobox>
        }
    } @else {
        <div class="text-wrap pb-1 pt-1.5">
            @if (customRoute) {
                <app-link [route]="[customRoute.path, value]" [checkPermission]="false">
                    {{ formatedSelectedOptions }}
                </app-link>
            } @else {
                {{ formatedSelectedOptions }}
            }
        </div>
    }
</app-input-label>
